export enum UserGroupMembershipPanelButtonId {
    ADD_USER_GROUP = "USER_DETAIL_ADD_USER_GROUP_BUTTON",
    REMOVE_USER_GROUP = "USER_DETAIL_REMOVE_USER_GROUP_BUTTON",
}
